// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkAssessmentEndGoalKindSchema = z.enum(['DOMAIN_COMPROMISE','CROWN_JEWELS'] as const);

export type InternalNetworkAssessmentEndGoalKindType = `${z.infer<typeof InternalNetworkAssessmentEndGoalKindSchema>}`

export default InternalNetworkAssessmentEndGoalKindSchema;
